import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Button, Stack, Typography } from '@mui/material'
import DOMPurify from 'dompurify'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { clampCss, COLORS, ICONS, LinkUnstyled, unit } from '@hcr/ui'

import { Path, EMPTY_PATH_PARAM } from '../../../../models'
import { to } from '../../../../utils'

interface DestinationInfoProps {
  description: string
  destinationId: string
  openDrawer: () => void
}

export const DestinationInfo: FC<DestinationInfoProps> = ({ description, destinationId, openDrawer }) => {
  const { t } = useTranslation()

  return (
    <>
      <Stack direction='row' alignItems='center' gap={unit(2)}>
        <FontAwesomeIcon icon={ICONS.farInfoCircle} />
        <Typography component='h2' variant='titleS'>
          {t('home.destination-info')}
        </Typography>
      </Stack>
      <Box>
        <Typography
          variant='bodyM'
          css={clampCss(4)}
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(description) }}
        />
        <Typography
          component='a'
          role='link'
          tabIndex={0}
          onClick={openDrawer}
          onKeyDown={event => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault()
              openDrawer()
            }
          }}
          variant='textLinkM'
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: unit(1),
            cursor: 'pointer',
            alignSelf: 'flex-start',
            WebkitTapHighlightColor: 'transparent',
            outline: 'none',
          }}
          color={COLORS.linknega['500']}
        >
          {t('home.read-more')}
          <FontAwesomeIcon icon={ICONS.farArrowDown} />
        </Typography>
      </Box>
      <Button
        component={LinkUnstyled}
        to={to([Path.Services, { destinationId: destinationId ?? EMPTY_PATH_PARAM }])}
        variant='outlined'
        color='white'
      >
        {t('home.explore-services')}
      </Button>
    </>
  )
}
